import { useCallback } from "react";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { useHttp } from "~hooks/useHttp.js";
import { useNotification } from "~hooks/useNotification";

const useUpdateTeam = () => {
  const { sport, organizationId, dataId } = useParams();
  const notification = useNotification();
  const { loading, error, request, cleanError } = useHttp();
  const { formatMessage } = useIntl();

  const updateTeamRequest = useCallback(
    async (body = {}) => {
      try {
        const res = await request({
          url: `/v1/${sport}/o/${organizationId}/entities/${dataId}`,
          method: "PUT",
          body: body,
        });
        const data = res?.data?.[0] || {};
        notification.success({
          message: formatMessage({
            id: "team.update.success",
          }),
          placement: "bottomRight",
        });
      } catch (e) {
        notification.error({
          message: formatMessage({
            id: "team.update.error",
          }),
          placement: "bottomRight",
        })
        console.error(e);
      }
    },
    [dataId, formatMessage, organizationId, request, sport],
  );
  return { updateTeamRequest, loading };
};

export default useUpdateTeam;
